import React from "react";
import { Container } from "react-bootstrap";
import Lottie from "react-lottie";
import animationData from "./blog-animation.json";
import classes from "./Blog.module.css";
const BlogsComingSoon = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid ",
    },
  };
  return (
    <div>
      <div className={classes.blogsComingSoonDesktop}>
        <Lottie options={defaultOptions} height={500} width={500} />
      </div>
      <div className={classes.blogsComingSoonMobile}>
        <Lottie options={defaultOptions} height={350} width={350} />
      </div>
    </div>
  );
};

export default BlogsComingSoon;
